<template>

  <span>

    <span class="datumLetzerBesuchsbericht" v-if="datum">
        {{ datum && datum != '---' ? javaDateToDefaultDateFormat(datum) : '--' }}
    </span>
    <span v-else-if="loading">
      <b-icon icon="clock" animation="spin" font-scale="1"></b-icon>
    </span>

  </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true

    export default {
      name: 'DatumLetzterBesuchsbericht',
      props: ['customer'],
      data () {
          return {
            datum: null,
            loading: true,
          }
      },
      watch: {
        customer: function () {
            this.init()
        }
      },
      created () {
        this.init()
      },
      methods: {

        init: function () {

          // prüfe ob das Datum bereits im Customer gecacht ist
          if (this.customer && this.customer.ended) {
            this.datum = this.customer.ended
            this.loading = false
            console.log('Datum für customer bereits gesetzt', this.customer.ended)
            return
          }

          this.datum   = null
          this.loading = true
          if (this.customer) {

            const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getLastBesuchsbericht'
            const params  = {
              customer_id: this.customer.id,
              ignore_247: true,
            }

            const that = this
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

              if (response.data) {

                if (response.data.auftrag) {
                  // es ist ein Besuchsbericht, da er einen Auftrag hat:
                  that.datum = response.data.endedOffice ? response.data.endedOffice : response.data.ended
                  if (!that.datum) {
                    that.datum = '---'
                  }
                  that.$emit('set-letzter-besuchsbericht', {
                    letzterBesuch: that.datum,
                    customer: that.customer,
                  })
                } else {
                  // es ist ein Monatsbericht
                  that.datum = response.data.ended
                  if (!that.datum) {
                    that.datum = '---'
                  }
                  that.$emit('set-letzter-besuchsbericht', {
                    letzterBesuch: that.datum,
                    customer: that.customer,
                  })
                }

              }
              that.loading = false

            }).catch(error => {
              console.log(error)
              that.loading = false
            })

          }

        },

      } // end methods

    }

</script>